import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '../layout/Layout.vue'
import store from '../store'

Vue.use(VueRouter)

// 添加前台路由（不需要Layout布局）
const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
    meta: { title: '登录' }
  },
  // 例如，为首页添加affix属性
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('../views/DashboardView.vue'),
        meta: { title: '首页', requireAuth: true, affix: true } // 添加affix: true
      }
    ]
  },
  
  // 在现有路由配置中添加以下路由
  // 在 report 路由组中添加
  {
    path: '/report',
    component: Layout,
    redirect: '/report/list',
    meta: { title: '报告管理', requireAuth: true },
    children: [
      {
        path: 'list',
        name: 'ReportList',
        component: () => import('../views/report/ReportList.vue'),
        meta: { title: '报告管理', requireAuth: true }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/resetpassword',
    children: [
      {
        path: 'resetpassword',
        name: 'Resetpassword',
        component: () => import('../views/ResetPassword.vue'),
        meta: { title: '修改密码', requireAuth: true }
      },
      {
        path: 'signature',
        name: 'Signature',
        component: () => import('../views/Signature.vue'),
        meta: { title: '设置签名', requireAuth: true }
      }
    ]
  },
  // 在basic路由组中添加标签管理路由
  {
    path: '/basic',
    component: Layout,
    redirect: '/basic/hospital',
    meta: { title: '基本管理', requireAuth: true },
    children: [
      {
        path: 'hospital',
        name: 'HospitalManage',
        component: () => import('../views/basic/HospitalManage.vue'),
        meta: { title: '医院管理', requireAuth: true }
      },
      {
        path: 'hospital/doctors/:id',
        name: 'HospitalDoctors',
        component: () => import('../views/basic/HospitalDoctors.vue'),
        meta: { title: '医院医生', requireAuth: true }
      },
      {
        path: 'patient',
        name: 'PatientManage',
        component: () => import('../views/basic/PatientManage.vue'),
        meta: { title: '患者管理', requireAuth: true }
      },
      {
        path: 'patientGroup',
        name: 'PatientGroup',
        component: () => import('../views/basic/PatientGroup.vue'),
        meta: { title: '患者组管理', requireAuth: true }
      },
      
    ]
  },
  {
    path: '/doctor',
    component: Layout,
    redirect: '/doctor/patient',
    meta: { title: '患者列表', requireAuth: true },
    children: [
      {
        path: 'patient',
        name: 'PatientList',
        component: () => import('../views/doctor/PatientList.vue'),
        meta: { title: '患者列表', requireAuth: true }
      },
      {
        path: 'patient/:id/:name',
        name: 'PatientDetail',
        component: () => import('../views/doctor/Patient.vue'),
        meta: { title: '患者', requireAuth: true }
      },
      {
        path:'group',
        name: 'GroupList',
        component: () => import('../views/doctor/GroupList.vue'),
        meta: { title: '患者组列表', requireAuth: true }
      },
      {
        path: 'records/:id',
        name: 'RecordsDetail',
        component: () => import('../views/doctor/Records.vue'),
        meta: { title: '表单填写记录', requireAuth: true }
      },
      {
        path: 'glucose-records/:id',
        name: 'GlucoseRecords',
        component: () => import('../views/report/GlucoseRecords.vue'),
        meta: { title: '血糖记录管理', requireAuth: true }
      },
      // 添加标签管理路由
      {
        path: 'tag',
        name: 'TagManage',
        component: () => import('../views/doctor/TagManage.vue'),
        meta: { title: '标签管理', requireAuth: true }
      },
      {
        path: 'notification',
        name: 'NotificationList',
        component: () => import('../views/doctor/NotificationList.vue'),
        meta: { title: '通知列表', requireAuth: true }
      },
      {
        path: 'export',
        name: 'ExportData',
        component: () => import('../views/doctor/ExportData.vue'),
        meta: { title: '数据导出', requireAuth: true }
      }
    ]
  },

  {
    path: '/form-manage',
    component: Layout,
    redirect: '/form-manage/list',
    meta: { title: '表单管理', requireAuth: true },
    children: [
      {
        path: 'list',
        name: 'FormManage',
        component: () => import('../views/form/FormManage.vue'),
        meta: { title: '表单管理', requireAuth: true }
      },
      {
        path: 'records',
        name: 'FormRecords',
        component: () => import('../views/form/Records.vue'),
        meta: { title: '表单填写记录', requireAuth: true }
      },
      {
        path: '/form-design/:id',
        name: 'FormDesign',
        component: () => import('../views/form/FormDesign.vue'),
        meta: { title: '表单设计', requireAuth: true }
      }
    ]
  },
  {
    path: '/task',
    component: Layout,
    redirect: '/task/list',
    meta: { title: '任务管理', requireAuth: true },
    children: [
      {
        path: 'list',
        name: 'TaskList',
        component: () => import('../views/task/TaskList.vue'),
        meta: { title: '任务管理', requireAuth: true }
      },
    ]
  },
  {
    path: '/glucose',
    component: Layout,
    redirect: '/dashboard',
    children: [{
      path: 'dashboard',
      name: 'GlucoseDashboard',
      component: () => import('../views/GlucoseDashboard.vue'),
      meta: { title: '数据看板', requireAuth: true }
    }]
  },
  {
    path: '/banner',
    component: Layout,
    redirect: '/banner/list',
    meta: { title: '轮播图管理', requireAuth: true },
    children: [
      {
        path: 'list/:id',
        name: 'BannerList',
        component: () => import('../views/carousel/Banner.vue'),
        meta: { title: '轮播图管理', requireAuth: true }
      },
    ]
  },
  {
    path: '/advertising',
    component: Layout,
    redirect: '/advertising/list',
    meta: { title: '广告位管理', requireAuth: true },
    children: [
      {
        path: 'list/:id',
        name: 'AdvertisingList',
        component: () => import('../views/carousel/Advertising.vue'),
        meta: { title: '广告位管理', requireAuth: true }
      },
    ]
  },
  // 前台表单相关路由
  // {
  //   path: '/public',
  //   redirect: '/public/forms',
  //   component: () => import('../views/public/PublicLayout.vue'),
  //   children: [
  //     {
  //       path: 'forms',
  //       name: 'PublicForms',
  //       component: () => import('../views/public/FormList.vue'),
  //       meta: { title: '表单列表' }
  //     },
  //     {
  //       path: 'form/:id',
  //       name: 'PublicFormDetail',
  //       component: () => import('../views/public/FormDetail.vue'),
  //       meta: { title: '表单填写' }
  //     },
  //     {
  //       path: 'success',
  //       name: 'SubmitSuccess',
  //       component: () => import('../views/public/SubmitSuccess.vue'),
  //       meta: { title: '提交成功' }
  //     }
  //   ]
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  document.title = to.meta.title || '血糖数据分析系统'

  // 判断该路由是否需要登录权限
  if (to.matched.some(record => record.meta.requireAuth)) {
    // 判断是否已登录 - using namespaced getter
    if (!store.getters['user/token']) {
      next({
        path: '/login',
        query: { redirect: to.fullPath } // 将要跳转的路由path作为参数
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router


